import { CSSProperties } from 'react';

export const StartIcon = () => <Icon style={{ transform: 'rotate(90deg)' }} />;
export const EndIcon = () => <Icon style={{ transform: 'rotate(-90deg)' }} />;

const Icon = ({ style }: { style: CSSProperties }) => (
  <svg
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.5002 32.4438L39.974 16.97L38.5598 15.5557L24.5002 29.6154L10.4406 15.5557L9.02637 16.97L24.5002 32.4438Z"
      fill="currentColor"
    />
  </svg>
);
